// extracted by mini-css-extract-plugin
module.exports =  {"container":"_93444fe79c--container--gRqtl","content":"_93444fe79c--content--Du_h4","title":"_93444fe79c--title--PzJ7W"};